// src/components/ambassadors/EarningsCard.tsx
import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";

interface EarningsCardProps {
  purchases: number;
  earnings: number;
}

export function EarningsCard({ purchases, earnings }: EarningsCardProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="bg-gradient-to-br from-amber-500/10 to-rose-500/10 border border-amber-500/20 rounded-2xl p-6"
    >
      <div className="flex justify-between items-center mb-2">
        <p className="text-white/60 text-xs md:text-sm">{purchases} purchases</p>
        <TrendingUp size={14} className="text-amber-400" />
      </div>
      <p className="text-2xl md:text-3xl font-black text-white">KES {earnings}</p>
      <p className="text-[9px] md:text-[10px] uppercase tracking-wider text-amber-400/60 mt-2">
        earnings
      </p>
    </motion.div>
  );
}
